import { Card } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type EmployeesPerLegalEntity from 'modules/insights/lib/metrics/employeesPerLegalEntity'

import BlankSlate from '../BlankSlate'
import EmployeesPerLegalEntityChart from './EmployeesPerLegalEntityChart'

interface Props {
  employeesPerLegalEntity: EmployeesPerLegalEntity
}

const WidgetEmployeesPerLegalEntity = ({ employeesPerLegalEntity }: Props) => (
  <Card>
    <Card.Title tooltip={i18n.t('insights.widgets.employee_per_legal_entity.tooltip')}>
      {i18n.t('insights.widgets.employee_per_legal_entity.title')}
    </Card.Title>
    <Card.Content>
      {employeesPerLegalEntity.isEmpty() ? (
        <BlankSlate />
      ) : (
        <EmployeesPerLegalEntityChart employeesPerLegalEntity={employeesPerLegalEntity} />
      )}
    </Card.Content>
  </Card>
)

export default WidgetEmployeesPerLegalEntity
